var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitloopsFullWhiteBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 450",
    style: {
      enableBackground: "new 0 0 1920 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7404E4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.59,
    y: 260.91,
    className: "st0",
    width: 33.68,
    height: 33.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.68,
    y: 211.52,
    className: "st0",
    width: 35.92,
    height: 35.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.14,
    y: 309.18,
    className: "st0",
    width: 29.19,
    height: 29.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.36,
    y: 333.88,
    className: "st0",
    width: 26.94,
    height: 26.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.21,
    y: 340.62,
    className: "st0",
    width: 24.7,
    height: 24.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.06,
    y: 323.78,
    className: "st0",
    width: 23.57,
    height: 23.57
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 290.1,
    className: "st0",
    width: 22.45,
    height: 22.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.81,
    y: 246.32,
    className: "st0",
    width: 19.08,
    height: 19.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.81,
    y: 198.05,
    className: "st0",
    width: 17.96,
    height: 17.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.53,
    y: 159.88,
    className: "st0",
    width: 16.84,
    height: 16.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.84,
    y: 125.08,
    className: "st0",
    width: 15.72,
    height: 15.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.74,
    y: 103.75,
    className: "st0",
    width: 13.47,
    height: 13.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.52,
    y: 99.26,
    className: "st0",
    width: 12.35,
    height: 12.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.55,
    y: 112.73,
    className: "st0",
    width: 11.23,
    height: 11.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.35,
    y: 139.67,
    className: "st0",
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.01,
    y: 164.37,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 563.6926 362.4183)",
    className: "st0",
    width: 33.68,
    height: 33.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.95,
    y: 120.59,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 613.0865 270.3662)",
    className: "st0",
    width: 29.19,
    height: 29.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.98,
    y: 98.14,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 702.8934 223.2175)",
    className: "st0",
    width: 26.94,
    height: 26.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.37,
    y: 93.65,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 799.4359 211.9917)",
    className: "st0",
    width: 24.7,
    height: 24.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.64,
    y: 111.61,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 894.8558 246.7919)",
    className: "st0",
    width: 23.57,
    height: 23.57
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.93,
    y: 146.41,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 972.3143 315.2697)",
    className: "st0",
    width: 22.45,
    height: 22.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.38,
    y: 193.56,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1013.85 406.1992)",
    className: "st0",
    width: 19.08,
    height: 19.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.51,
    y: 242.95,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1014.9727 503.8643)",
    className: "st0",
    width: 17.96,
    height: 17.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.91,
    y: 282.24,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 984.6628 581.3228)",
    className: "st0",
    width: 16.84,
    height: 16.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.72,
    y: 318.16,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 925.1657 652.0458)",
    className: "st0",
    width: 15.72,
    height: 15.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.07,
    y: 341.74,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 837.6039 696.9493)",
    className: "st0",
    width: 13.47,
    height: 13.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.41,
    y: 347.35,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 751.1647 707.0526)",
    className: "st0",
    width: 12.35,
    height: 12.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 335,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 660.2352 681.233)",
    className: "st0",
    width: 11.23,
    height: 11.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.83,
    y: 309.18,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 591.7573 628.4715)",
    className: "st0",
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.68,
    y: 172.23,
    className: "st0",
    width: 6.74,
    height: 6.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.87,
    y: 280,
    className: "st0",
    width: 6.74,
    height: 6.74
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M661.74,60.38v94.72c8.65-8.65,18.01-15.14,28.06-19.47c10.06-4.32,20.81-6.49,32.27-6.49 c24.91,0,46.07,9.41,63.5,28.24c17.42,18.83,26.14,42.97,26.14,72.44c0,28.42-9.01,52.18-27.01,71.3 c-18.01,19.12-39.35,28.68-64.02,28.68c-10.99,0-21.22-1.96-30.7-5.88c-9.47-3.92-18.89-10.32-28.24-19.21v20.17H614.2V60.38 H661.74z M712.08,173.34c-15.08,0-27.6,5.15-37.54,15.44c-9.94,10.29-14.91,23.74-14.91,40.34c0,16.96,4.97,30.67,14.91,41.13 c9.94,10.47,22.45,15.7,37.54,15.7c14.62,0,26.92-5.32,36.92-15.96c10-10.64,15-24.21,15-40.69c0-16.37-4.91-29.79-14.73-40.26 C739.44,178.57,727.04,173.34,712.08,173.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M870.03,55.47c8.39,0,15.59,3.04,21.6,9.12c6,6.08,9.01,13.45,9.01,22.1c0,8.54-2.97,15.82-8.92,21.84 c-5.95,6.02-13.06,9.03-21.34,9.03c-8.51,0-15.77-3.07-21.78-9.21c-6-6.14-9.01-13.59-9.01-22.36c0-8.42,2.97-15.61,8.92-21.57 S861.63,55.47,870.03,55.47z M846.09,134.05h47.89v190.84h-47.89V134.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M943.26,63.71h47.89v70.34h28.42v41.22h-28.42v149.62h-47.89V175.27H918.7v-41.22h24.56V63.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1039.91,60.38h47.89v264.51h-47.89V60.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1220.93,129.13c18.01,0,34.93,4.5,50.78,13.51c15.84,9.01,28.21,21.22,37.1,36.66 c8.89,15.44,13.33,32.1,13.33,49.99c0,18.01-4.47,34.85-13.42,50.52c-8.95,15.67-21.14,27.92-36.57,36.75 c-15.44,8.83-32.45,13.24-51.04,13.24c-27.36,0-50.72-9.73-70.07-29.2c-19.35-19.47-29.03-43.12-29.03-70.95 c0-29.82,10.93-54.67,32.8-74.55C1173.97,137.79,1196.02,129.13,1220.93,129.13z M1221.71,174.21c-14.88,0-27.26,5.17-37.16,15.52 c-9.9,10.35-14.85,23.59-14.85,39.73c0,16.61,4.89,30.05,14.67,40.34c9.78,10.29,22.17,15.44,37.16,15.44 c14.99,0,27.47-5.2,37.42-15.61c9.95-10.41,14.93-23.79,14.93-40.17c0-16.37-4.89-29.67-14.67-39.9 C1249.45,179.33,1236.94,174.21,1221.71,174.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1417.2,129.13c18.01,0,34.93,4.5,50.78,13.51c15.84,9.01,28.21,21.22,37.1,36.66 c8.89,15.44,13.33,32.1,13.33,49.99c0,18.01-4.47,34.85-13.42,50.52c-8.95,15.67-21.14,27.92-36.57,36.75 c-15.44,8.83-32.45,13.24-51.04,13.24c-27.36,0-50.72-9.73-70.07-29.2c-19.35-19.47-29.03-43.12-29.03-70.95 c0-29.82,10.93-54.67,32.8-74.55C1370.25,137.79,1392.3,129.13,1417.2,129.13z M1417.99,174.21c-14.88,0-27.26,5.17-37.16,15.52 c-9.9,10.35-14.85,23.59-14.85,39.73c0,16.61,4.89,30.05,14.67,40.34c9.78,10.29,22.17,15.44,37.16,15.44 c14.99,0,27.47-5.2,37.42-15.61c9.95-10.41,14.93-23.79,14.93-40.17c0-16.37-4.89-29.67-14.67-39.9 C1445.72,179.33,1433.22,174.21,1417.99,174.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1605.06,134.05v21.05c8.65-8.65,18.01-15.14,28.06-19.47c10.06-4.32,20.81-6.49,32.27-6.49 c24.91,0,46.07,9.41,63.5,28.24c17.42,18.83,26.14,42.97,26.14,72.44c0,28.42-9.01,52.18-27.01,71.3 c-18.01,19.12-39.35,28.68-64.02,28.68c-10.99,0-21.22-1.96-30.7-5.88s-18.89-10.32-28.24-19.21v89.98h-47.53V134.05H1605.06z  M1655.4,173.34c-15.08,0-27.6,5.15-37.54,15.44c-9.94,10.29-14.91,23.74-14.91,40.34c0,16.96,4.97,30.67,14.91,41.13 c9.94,10.47,22.45,15.7,37.54,15.7c14.62,0,26.92-5.32,36.92-15.96c10-10.64,15-24.21,15-40.69c0-16.37-4.91-29.79-14.73-40.26 C1682.76,178.57,1670.37,173.34,1655.4,173.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1911.49,160.71l-29.64,29.64c-12.05-11.93-22.98-17.89-32.8-17.89c-5.38,0-9.59,1.14-12.63,3.42 c-3.04,2.28-4.56,5.12-4.56,8.51c0,2.57,0.96,4.94,2.89,7.1c1.93,2.17,6.69,5.12,14.3,8.86l17.54,8.77 c18.47,9.12,31.16,18.42,38.06,27.89c6.9,9.47,10.35,20.58,10.35,33.33c0,16.96-6.23,31.11-18.68,42.45 c-12.45,11.34-29.15,17.01-50.08,17.01c-27.83,0-50.05-10.88-66.65-32.63l29.47-32.1c5.61,6.55,12.19,11.84,19.73,15.87 s14.24,6.05,20.08,6.05c6.31,0,11.4-1.52,15.26-4.56c3.86-3.04,5.79-6.55,5.79-10.52c0-7.37-6.96-14.56-20.87-21.57l-16.14-8.07 c-30.87-15.55-46.31-35.02-46.31-58.41c0-15.08,5.82-27.98,17.45-38.68c11.63-10.7,26.51-16.05,44.64-16.05 c12.39,0,24.06,2.72,34.99,8.16C1894.62,142.73,1903.89,150.53,1911.49,160.71z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitloopsFullWhiteBackground);
export default __webpack_public_path__ + "static/media/Bitloops-Full-White-Background.a9e67082a6eeb6cafc5475567481e585.svg";
export { ForwardRef as ReactComponent };